import { render, staticRenderFns } from "./BusParticipant.vue?vue&type=template&id=cc29cbf8&scoped=true"
import script from "./BusParticipant.vue?vue&type=script&lang=ts"
export * from "./BusParticipant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc29cbf8",
  null
  
)

export default component.exports